export { componentCapabilities as capabilities, getComponentTemplate, setComponentTemplate } from '../../@glimmer/manager/index.js';
import '../../@glimmer/opcode-compiler/index.js';
export { I as Input, T as Textarea, C as default } from '../../shared-chunks/index-D7YmuLah.js';
import '../../shared-chunks/registry-BJpQx6hv.js';
import '../debug/index.js';
import '../../@glimmer/runtime/index.js';
import '../runloop/index.js';
import '../../@glimmer/reference/index.js';
import '../../@glimmer/validator/index.js';
import '@embroider/macros';
export { s as setComponentManager } from '../../shared-chunks/managers-CbMgnSoo.js';
